export default __webpack_public_path__ + "static/media/crystals.bdbd9ab3.png";